export const MILLISECONDS_FROM_END_TO_COUNT_AS_FINISHED = 15000
export const REMOTE_SYNC_INTERVAL = 60000
export const LOCAL_SYNC_INTERVAL = 3000
export const PROGRESS_UPDATE_INTERVAL = 1000
